import * as React from 'react';

export default function DevicePage() {
  return (    
    <h1>Device page</h1>
  );
}